<template>
  <div class="ca-kpis" :style="{ '--ca-kpi-columns': columns }">
    <div v-for="card in cards" :key="card.key" class="ca-kpi-card">
      <div class="ca-kpi-card__label">{{ $t(card.label) }}</div>
      <div class="ca-kpi-card__value">{{ card.value }}</div>
      <div v-if="card.sub" class="ca-kpi-card__sub">{{ card.sub }}</div>
    </div>
  </div>
</template>

<script>
/**
 * Row of headline cards shared by the Shift and History views.
 * @typedef {{ key: string, label: string, value: string|number, sub?: string }} KpiCard
 */
export default {
  props: {
    /** @type {import('vue').PropType<KpiCard[]>} */
    cards: { type: Array, required: true },
    columns: { type: Number, required: true },
  },
}
</script>

<style lang="scss" scoped>
.ca-kpis {
  display: grid;
  grid-template-columns: repeat(var(--ca-kpi-columns), 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.ca-kpi-card {
  background: #fff;
  border: 1px solid #eef0f3;
  border-radius: 10px;
  padding: 14px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  &__label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7f8c8d;
    margin-bottom: 8px;
  }

  &__value {
    font-size: 1.6rem;
    font-weight: 700;
    color: #2c3e50;
    line-height: 1.1;
  }

  &__sub {
    margin-top: 6px;
    font-size: 0.74rem;
    color: #9aa5b1;
  }
}

@media (max-width: 991px) {
  .ca-kpis {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-bottom: 12px;
  }

  .ca-kpi-card {
    padding: 12px 14px;
  }
}

@media (max-width: 767px) {
  .ca-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .ca-kpi-card {
    padding: 10px 12px;

    &__label {
      font-size: 0.68rem;
      margin-bottom: 6px;
    }

    &__value {
      font-size: 1.35rem;
    }

    &__sub {
      font-size: 0.7rem;
      margin-top: 4px;
    }
  }
}

@media (max-width: 520px) {
  .ca-kpis {
    grid-template-columns: 1fr;
  }

  .ca-kpi-card__value {
    font-size: 1.4rem;
  }
}
</style>
